import { Box, Button, Loader, LoadingOverlay, Paper, Select, SimpleGrid, Space, Text, Textarea, TextInput, Title } from '@mantine/core'
import React, { memo, useEffect, useState } from 'react'
import useFetch from '../../../../Customhooks/useFetch';
import { useNavigate, useParams } from 'react-router-dom';
import { baseUrl } from '../../../../Constants/constant';
import { notifications } from '@mantine/notifications';
import classes from '../MaterialSubType.module.css'

const AddMaterialSubType = () => {
    const navigate = useNavigate();
    const [weightType, setWeightType] = useState<any>();
    const [subtypename, setSubTypeName] = useState<string>('');
    const [waterconsumption, setWaterConsumption] = useState<string>('');
    const [sourcename, setSourceName] = useState<string>('');
    const [dbversion, setDBVersion] = useState<any>();
    const [selectedDBversion, setSelectedDBVersion] = useState<any>();
    const [source, setSource] = useState<string>('');
    const [verticals, setVerticals] = useState<any>();
    const [selectedVertical, setSelectedVertical] = useState<any>();
    const [rawmaterial, setRawMaterial] = useState<any>();
    const [selectedmaterial, setSelectedMaterial] = useState<any>();
    // const [factory, setFactory] = useState<any>();
    // const [selectedfactory, setSelectedFactory] = useState<any>();
    const [process, setProcess] = useState<any>();
    const [selectedProcess, setSelectedProcess] = useState<any>();
    const [sourceDescription, setSourceDescription] = useState<any>();
    const [cotwo, setCoTwo] = useState<string>('');
    const [errors, setErrors] = useState<Record<string, string>>({});
    const token = localStorage.getItem("token")
    const { id } = useParams();

    const fetchConfig = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            token: token,
        },
    };

    const url = id ? `${baseUrl}admin/raw-material-sub-types/update/${id}` : `${baseUrl}admin/raw-material-sub-types/add`
    const {
        data: getData,
        loading: detailLoading,
        error: getError,
        fetchData: postSubType,
    } = useFetch({
        method: id ? 'PUT' : 'POST',
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
        body: JSON.stringify({
            material_id: selectedmaterial,
            vertical_id: selectedVertical,
            sub_name: subtypename,
            water_consumption: waterconsumption,
            co2_embodiment: cotwo,
            source_name: sourcename,
            source: source,
            database_version_id: selectedDBversion,
            description: sourceDescription,
            // factory_id: selectedfactory,
            process_id: selectedProcess,
            weight_type: weightType,
        }),
    });
    const { data: getverticalData, fetchData: getVerticals } = useFetch(fetchConfig);
    const { data: getDataversion, fetchData: getDbversions } = useFetch(fetchConfig);
    const { data: getrawmaterialData, fetchData: getrawmaterial } = useFetch(fetchConfig);
    // const { data: getFactoryData, fetchData: getFactory } = useFetch(fetchConfig);
    const { data: getProcessData, loading: LoadingProcess, error: errorProcess, fetchData: getProcess } = useFetch(fetchConfig);
    const { data: getfieldData, loading: fieldLoading, fetchData: getfield } = useFetch(fetchConfig);
    useEffect(() => {
        getVerticals(`${baseUrl}admin/verticals`);
        getDbversions(`${baseUrl}admin/database-version`);
        getProcess(`${baseUrl}admin/process`);
        // getFactory(`${baseUrl}admin/factories`);
        if (id) {
            getfield(`${baseUrl}admin/raw-material-sub-types/${id}`)
        }
    }, [])
    useEffect(() => {
        if (getfieldData?.data?.rows?.length && verticals?.length) {
            // const data = response.data.rows[0];
            setSubTypeName(getfieldData?.data?.rows[0]?.sub_name);
            setCoTwo(getfieldData?.data?.rows[0]?.co2_embodiment);
            setWaterConsumption(getfieldData?.data?.rows[0]?.water_consumption);
            setSourceName(getfieldData?.data?.rows[0]?.source_name);
            setSource(getfieldData?.data?.rows[0]?.source);
            setSourceDescription(getfieldData?.data?.rows[0]?.description);
            setWeightType(getfieldData?.data?.rows[0]?.Weighttype?.id.toString());

            setSelectedVertical((prev: any) =>
                prev !== undefined && prev !== null
                    ? prev
                    : (verticals?.find((v: any) => v.label === getfieldData?.data?.rows[0]?.Vertical?.vertical_name)?.value ?? null)
            );
            // setSelectedFactory((prev: any) =>
            //     prev !== undefined && prev !== null
            //         ? prev
            //         : (factory?.find((v: any) => v.label === getfieldData?.data?.rows[0]?.Factory?.factory_name)?.value ?? null)
            // );
            setSelectedDBVersion((prev: any) =>
                prev !== undefined && prev !== null
                    ? prev
                    : (dbversion?.find((v: any) => v.label === getfieldData?.data?.rows[0]?.DatabaseVersion?.db_version)?.value ?? null)
            );

            // Ensure rawmaterial exists before calling find
            if (rawmaterial?.length > 0 && getfieldData?.data?.rows[0]?.RawMaterial) {
                const matchingrawmaterial = rawmaterial?.find(
                    (v: any) => v.label === getfieldData?.data?.rows[0]?.RawMaterial?.material_name
                );
                setSelectedMaterial(matchingrawmaterial?.value || null);
            }
            if (process?.length > 0 && getfieldData?.data?.rows[0]?.Process) {
                const matchingprocess = process?.find(
                    (v: any) => v.label === getfieldData?.data?.rows[0]?.Process?.process_name
                );
                setSelectedProcess(matchingprocess?.value || null);
            }
        }
    }, [getfieldData, verticals, rawmaterial, process]);

    useEffect(() => {
        if (selectedVertical) {
            setSelectedMaterial(null);
            setRawMaterial([]);
            getrawmaterial(`${baseUrl}admin/raw-materials?vertical_id=${selectedVertical}`);
        }
    }, [selectedVertical])
    // useEffect(() => {
        // if (selectedfactory) {
            // setSelectedProcess(null);
            // setProcess([]);
            
        // }
    // }, [])
    useEffect(() => {
        if (getProcessData?.data?.rows) {
            setProcess(getProcessData?.data?.rows?.map((el: any) => ({
                value: el?.id.toString(),
                label: el?.process_name,
            }))
            );
        }
    }, [getProcessData])
    useEffect(() => {
        if (getrawmaterialData?.data?.rows) {
            setRawMaterial(getrawmaterialData?.data?.rows?.map((el: any) => ({
                value: el?.id.toString(),
                label: el?.material_name,
            }))
            );
        }
    }, [getrawmaterialData, selectedVertical])
    useEffect(() => {
        if (getverticalData?.data?.rows) {
            setVerticals(
                getverticalData?.data?.rows?.map((el: any) => ({
                    value: el?.vertical_id?.toString(),
                    label: el?.vertical_name,
                }))
            );
        }
    }, [getverticalData]);
    // useEffect(() => {
    //     if (getFactoryData?.data?.rows) {
    //         setFactory(
    //             getFactoryData?.data?.rows?.map((el: any) => ({
    //                 value: el?.id.toString(),
    //                 label: el?.factory_name,
    //             }))
    //         );
    //     }
    // }, [getFactoryData]);
    useEffect(() => {
        if (getDataversion?.data?.rows) {
            setDBVersion(
                getDataversion?.data?.rows?.map((el: any) => ({
                    value: el?.id.toString(),
                    label: el?.db_version,
                }))
            );
        }
    }, [getDataversion]);

    const handleChange = (field: string, value: string | null) => {
        if (field === "material_name") {
            setSelectedMaterial(value);
        } else if (field === "vertical_id") {
            setSelectedVertical(value);
        }
        else if (field === "dbversion_id") {
            setSelectedDBVersion(value);
        }
        else if (field === "co2_id") {
            setCoTwo(value as string);
        }
        else if (field === "water_id") {
            setWaterConsumption(value as string);
        }
        else if (field === "subtype_id") {
            setSubTypeName(value as string);
        }
        else if (field === "sourcename_id") {
            setSourceName(value as string);
        }
        else if (field === "source_id") {
            setSource(value as string);
        }
        else if (field === "source_description") {
            setSourceDescription(value as string);
        }
        // else if (field === "factory_name") {
        //     setSelectedFactory(value);
        // }
        else if (field === "process_name") {
            setSelectedProcess(value);
        }
        else if (field === "weight_type") {
            setWeightType(value);
        }
        // Remove the error for the field if it's being updated
        setErrors((prev: any) => ({ ...prev, [field]: undefined }));
    };

    // **Validate inputs before submitting**
    const validateFields = () => {
        let newErrors: Record<string, string> = {};

        if (!selectedmaterial) {
            newErrors.material_name = "Raw Material Name is Required";
        }
        if (!selectedVertical) {
            newErrors.vertical_id = "Vertical Name is Required";
        }
        if (!selectedDBversion) {
            newErrors.dbversion_id = "DB Version is Required";
        }
        if (!cotwo) {
            newErrors.co2_id = "CO₂ amount is Required";
        }
        if (!waterconsumption) {
            newErrors.water_id = "Water amount is Required";
        }
        if (!subtypename) {
            newErrors.subtype_id = "Sub Type Name is Required";
        }
        if (!sourcename) {
            newErrors.sourcename_id = "Source Name is Required";
        }
        if (!source) {
            newErrors.source_id = "Source is Required";
        }
        if (!sourceDescription) {
            newErrors.source_description = "Source Description is Required";
        }
        // if (!selectedfactory) {
        //     newErrors.factory_name = "Factory Name is Required";
        // }
        if (!selectedProcess) {
            newErrors.process_name = "Process Name is Required";
        }
        if (!weightType) {
            newErrors.weight_type = "Weight Type is Required";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false; // Validation failed
        }
        return true; // Validation passed
    };

    const handlesave = async (e: any) => {
        e.preventDefault();
        if (!validateFields()) return; // Stop if validation fails
        await postSubType(url);
    };

    useEffect(() => {
        const showNotification = (type: any, title = "An error occurred") => {
            notifications.show({
                title,
                message: type === 'success'
                    ? "Transport data saved successfully."
                    : "Something went wrong. Please try again.",
                color: type === 'success' ? "green" : "red",
                classNames: classes,
            });
        };

        if (getData?.errors || getError) {
            showNotification('error', getData?.message || getError?.message);
            return;
        }

        if (getData && !getData?.errors) {
            navigate('/material-subtype');
        }
    }, [getData, getError, navigate, classes]);
    return (
        <>
            <LoadingOverlay
                visible={fieldLoading}
                zIndex={1000}
                overlayProps={{
                    radius: 'sm',
                    blur: 2,
                    style: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                    }
                }}
                loaderProps={{ color: '#404040', type: 'bars' }}
            />
            <Paper shadow="xs" p="xs" radius="md">
                <Box ml={5}>
                    <Title order={4}>Add Raw Material Sub Type</Title>
                    <Space h="lg" />
                    <Text>Sub Materials Details</Text>
                    <Space h="xs" />
                    <SimpleGrid cols={4}>
                        <Select
                            label="Select Category"
                            withAsterisk
                            variant='filled'
                            placeholder='Select Category'
                            data={verticals}
                            searchable
                            maxDropdownHeight={200}
                            value={selectedVertical}
                            onChange={(value) => handleChange("vertical_id", value)}
                            radius={6}
                            error={errors.vertical_id}
                        />
                        <Select
                            label="Select Raw Materials"
                            withAsterisk
                            variant="filled"
                            placeholder="Select Raw Material"
                            data={rawmaterial}
                            searchable
                            maxDropdownHeight={200}
                            value={selectedmaterial}
                            onChange={(value) => handleChange("material_name", value)}
                            disabled={!rawmaterial || rawmaterial.length === 0}
                            radius={6}
                            error={errors.material_name}
                        />
                        <TextInput
                            label="Add Sub Type name"
                            placeholder="Enter raw material sub type"
                            variant='filled'
                            withAsterisk
                            value={subtypename}
                            onChange={(e) => handleChange("subtype_id", e.target.value)}
                            radius={6}
                            error={errors.subtype_id}
                        />
                        <TextInput
                            label="Water Consumption (liters)"
                            placeholder="Enter value"
                            variant='filled'
                            withAsterisk
                            value={waterconsumption}
                            onChange={(e) => handleChange("water_id", e.target.value)}
                            radius={6}
                            error={errors.water_id}
                        />
                        <TextInput
                            variant='filled'
                            placeholder="Enter as amount"
                            label="CO₂ Embodied per g"
                            withAsterisk
                            value={cotwo}
                            onChange={(e) => handleChange("co2_id", e.target.value)}
                            radius={6}
                            error={errors.co2_id}
                        />
                        <Select
                            label="Database Version"
                            placeholder='Select Version'
                            withAsterisk
                            variant='filled'
                            data={dbversion}
                            searchable
                            maxDropdownHeight={200}
                            value={selectedDBversion}
                            onChange={(value) => handleChange("dbversion_id", value)}
                            radius={6}
                            error={errors.dbversion_id}
                        />
                        <TextInput
                            label="Source Name"
                            placeholder="Enter source name"
                            variant='filled'
                            withAsterisk
                            value={sourcename}
                            onChange={(e) => handleChange("sourcename_id", e.target.value)}
                            radius={6}
                            error={errors.sourcename_id}
                        />
                        <TextInput
                            label="Source"
                            placeholder="Enter source"
                            withAsterisk
                            variant='filled'
                            value={source}
                            onChange={(e) => handleChange("source_id", e.target.value)}
                            radius={6}
                            error={errors.source_id}
                        />
                        {/*<Select
                            label="Select Factory"
                            placeholder="Select Factory"
                            withAsterisk
                            variant="filled"
                            data={factory}
                            searchable
                            maxDropdownHeight={200}
                            value={selectedfactory}
                            onChange={(value) => handleChange("factory_name", value)}
                            radius={6}
                            error={errors.factory_name}
                        />*/}
                        <Select
                            label="Select Process"
                            placeholder="Select Process"
                            withAsterisk
                            variant="filled"
                            data={process}
                            searchable
                            maxDropdownHeight={200}
                            value={selectedProcess}
                            onChange={(value) => handleChange("process_name", value)}
                            // rightSection={LoadingProcess ? <Loader size={18} /> : null}
                            radius={6}
                            error={errors.process_name}
                        />
                        <Select
                            label="Weight Type"
                            placeholder="Select Weight Type"
                            withAsterisk
                            variant="filled"
                            radius={6}
                            data={[{ value: '1', label: 'GSM' },
                            { value: '2', label: 'Gram' },]}
                            value={weightType}
                            onChange={(value) => handleChange("weight_type", value)}
                            error={errors.weight_type}
                        />
                    </SimpleGrid>
                    <Textarea
                        label="Source Description"
                        placeholder="Enter your Product Description"
                        withAsterisk
                        variant="filled"
                        autosize
                        value={sourceDescription}
                        onChange={(e) => handleChange("source_description", e.target.value)}
                        minRows={3}
                        maxRows={4}
                        radius={6}
                        error={errors.source_description}
                    />
                    <Space h="xl" />
                    <SimpleGrid cols={6}>
                        <Button
                            variant="default"
                            radius={6}
                            onClick={() => navigate('/material-subtype')}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="gradient"
                            gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                            radius={6}
                            onClick={(e) => handlesave(e)}
                            loading={detailLoading}
                        >
                            {id ? 'Update' : 'Save'}
                        </Button>
                    </SimpleGrid>
                </Box>
            </Paper>
        </>
    )
}

export default memo(AddMaterialSubType)